(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-feedaty"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (document.querySelector('script.feedaty_sdk')) return;

    const script = document.createElement('script');
    script.className = 'feedaty_sdk';
    script.src = 'https://widget.feedaty.com/v3.0.0/js/2021/10216625/feedaty.min.js';
    script.async = true;
    document.head.appendChild(script);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sidebar-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const submenu = button.nextElementSibling;

        button.setAttribute('aria-expanded', String(!isExpanded));
        if (!submenu) return;

        const openClass = submenu.classList.contains('collection-sidebar__submenu')
          ? 'collection-sidebar__submenu--open'
          : 'collection-sidebar__subsubmenu--open';
        submenu.classList.toggle(openClass, !isExpanded);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
